"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADMISIONS_ADVISOR = {
    CA: [
        "Michael Darling",
        "Eddie Cook",
        "John Pearce",
        "Arlandis McClain",
        "Theodore Crews",
        "Brianne Goines",
        "Jessica Jackson"
    ],
    NV: ["Cindia Eubanks", "Nick Novick", "Jessica Jackson", "Ty Taylor"],
    TX: ["Anthony Fisher", "Rachael Yvonne Davis", "Christian Flores", "Mariah Jones"]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2FtcHVzRm9ybS5jb25maWd1cmF0aW9uLmpzIiwic291cmNlUm9vdCI6Ii4vIiwic291cmNlcyI6WyJ2aWV3cy9Bc2hlci9wYXJ0cy9zdHVkZW50Rm9ybS9jYW1wdXNGb3JtLmNvbmZpZ3VyYXRpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBYSxRQUFBLGlCQUFpQixHQUFHO0lBQzdCLEVBQUUsRUFBRTtRQUNBLGlCQUFpQjtRQUNqQixZQUFZO1FBQ1osYUFBYTtRQUNiLGtCQUFrQjtRQUNsQixnQkFBZ0I7UUFDaEIsZ0JBQWdCO1FBQ2hCLGlCQUFpQjtLQUNwQjtJQUNELEVBQUUsRUFBRSxDQUFDLGdCQUFnQixFQUFFLGFBQWEsRUFBRSxpQkFBaUIsRUFBRSxXQUFXLENBQUM7SUFDckUsRUFBRSxFQUFFLENBQUMsZ0JBQWdCLEVBQUUsc0JBQXNCLEVBQUUsa0JBQWtCLEVBQUUsY0FBYyxDQUFDO0NBQ3JGLENBQUEifQ==